<template>
  <div id="validar-dados">
    <span class="titulo-tela">{{funcionalidade.parametros.textos.tituloTelaValidarDados}}</span>
    <span class="subtitulo-tela">{{funcionalidade.parametros.textos.subtituloTelaValidarDados}}</span>
    <div :id="idRender"/>
    <el-button @click="enviar" class="btn-confirmar" :style="`background-color: ${corBotaoPrincipal}`">
      <span :style="`color: ${corTextoBotaoPrincipal}`">{{funcionalidade.parametros.textos.labelBotaoTelaValidarDados}}</span>
    </el-button>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { renderForm } from '@mobilesaude/form-builder-sdk'
import useAppDataDriver from '@/utils/useAppDataDriver'

export default {
  name: 'StepFormulario',
  data () {
    return {
      form: null,
      formTimestamp: 1
    }
  },
  props: {
    paciente: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('SetupApp', ['funcionalidade', 'config']),
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('Func53', ['idAgenda']),
    idRender () {
      return `form-render-${this.formTimestamp}`
    },
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    },
    corBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corBotaoPrincipal
    },
    corTextoBotaoPrincipal () {
      return this.estilo.botaoPrincipal.corTextoBotaoPrincipal
    },
    formBuilderColors () {
      const colors = this.estilo.formBuilder

      if (!colors) {
        return {}
      }

      return {
        primary: colors.corPrincipalFormBuilder,
        errors: colors.corErroFormBuilder,
        alert: colors.corAlertaFormBuilder
      }
    }
  },
  methods: {
    ...mapActions('Login', ['setLogin']),
    ...mapActions('Func53', ['setResponsavelAtendimento', 'setDadosContato']),
    ...mapActions('BreadCrumbsStore', ['updateIten']),
    async init () {
      await this.setFormTimestamp()
      this.initForm()
      let step = null
      this.idAgenda === '2' ? step = 2 : step = 1
      const data = { step: step, value: this.paciente.nome }
      this.updateIten(data)
    },
    async setFormTimestamp () {
      this.formTimestamp = Date.now()
    },
    initForm () {
      const loader = this.$loading({
        lock: true,
        fullscreen: true,
        customClass: 'myloading'
      })

      const formId = this.funcionalidade.parametros.formularios.formularioValidarDados

      let params = {
        identifier: this.idRender,
        clientKey: this.config.aplicacao.clientKey,
        'idForm': formId,
        'colors': { ...this.formBuilderColors }
      }
      this.form = renderForm(params)
      this.form.on('LOADING', async res => {
        this.form.renderForm(await this.getJsonInjetado())
        setTimeout(() => {
          this.internalLoading = res
          loader.close()
        }, 300)
      })
      const responsavelAtendimento = {
        nome: this.paciente.nome,
        contato: this.paciente.beneficiarioDados.dadosPessoais.contato,
        chaveUnica: this.paciente.chaveUnica,
        numeroContrato: this.paciente.numeroContrato,
        integracao: this.paciente.integracao || null
      }
      this.setResponsavelAtendimento(responsavelAtendimento)
    },
    async getJsonInjetado () {
      const appDataDriver = useAppDataDriver()
      const keyCustomFields = await this.form.getKeyCustomFields()
      if (!Array.isArray(keyCustomFields.keyCustoms) || keyCustomFields.keyCustoms.length === 0) {
        return false
      }

      const payload = {
        camposFormbuiler: keyCustomFields.keyCustoms,
        beneficiarioSelecionado: this.paciente
      }

      return appDataDriver.formatJSON(payload)
    },
    async enviar () {
      const formData = await this.form.validateAll()
      if (!formData || !formData.status) {
        return this.showError()
      }
      const payload = formData.data
      this.setDadosContato(payload)
      const nextStep = parseInt(this.$route.query.step) + 1
      this.$router.replace({ query: { step: nextStep } })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');
.btn-confirmar {
  color: #FFFFFF;
  display: block;
  width: 100%;
  border: none;
  text-align: center;
  margin-top: 20px;
  padding: 12px;
}
.btn-confirmar:hover {
  color: #FFFFFF;
  display: block;
  width: 100%;
  border: none;
  text-align: center;
  margin-top: 20px;
  padding: 12px;
}
.titulo-tela {
  font-family: 'Open Sans', sans-serif;
  margin-bottom: 10px;
  display: block;
  font-size: 20px;
}
.subtitulo-tela {
  font-size: 14px;
  margin-bottom: 20px;
  display: block;
}
</style>
